<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/files/black</title>
    <g id="atoms/icons/30x30/files/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M12,4 L16.5,7.5 L24,7.5 C25.6568542,7.5 27,8.84314575 27,10.5 L27,23.7207207 C27,25.377575 25.6568542,26.7207207 24,26.7207207 L6,26.7207207 C4.34314575,26.7207207 3,25.377575 3,23.7207207 L3,7 C3,5.34314575 4.34314575,4 6,4 L12,4 Z M11.315,6 L6,6 C5.44771525,6 5,6.44771525 5,7 L5,23.7207207 C5,24.2730055 5.44771525,24.7207207 6,24.7207207 L24,24.7207207 C24.5522847,24.7207207 25,24.2730055 25,23.7207207 L25,10.5 C25,9.94771525 24.5522847,9.5 24,9.5 L15.8137845,9.5 L15.2721188,9.07870443 L11.315,6 Z M15,16.9459459 L15,18.9459459 L7.06163526,18.9459459 L7.06163526,16.9459459 L15,16.9459459 Z M17.3588414,13.0540541 L17.3588414,15.0540541 L7.06163526,15.0540541 L7.06163526,13.0540541 L17.3588414,13.0540541 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
